module.exports = __webpack_public_path__ + "img/icon-fund.5d4eb871.svg";